import React from "react";
import { Input, Row, Col, Label } from "reactstrap";
import "./styles.css";
import { Button, Form, Drawer, Spin, Popconfirm, Table, Select } from "antd";
import { message } from "antd";
import deleteBtn from "../../../Images/icons/delete.png";
import XslxGen from "../xslx";

const { Option } = Select;

export default class AdminTable extends React.Component {
  state = {
    searchField: "",
    modal2Visible: false,
    currentSelectedUser: [],
    visible: false,
    users: [],
    result:[],
    userId: "",
    name: "",
    batch: "",
    usertype: "",
    email: "",
    company: "",
    password: "",
    errors: {},
    editMode: false,
    columns: [
     
      {
        title: "Name",
        width: "18%",
        key: "Name",
        render: (record) => (
          <p
            className="grow titleText"
            style={{ cursor: "pointer" }}
            onClick={() => this.editUser(record)}
          >
            <b>{record.name}</b>
          </p>
        ),
      },
      {
        title: "Email",
        dataIndex: "email",
        width: "13%",
        key: "Email",
      },
      {
        title: "Company",
        dataIndex: "company",
        width: "20%",
        key: "Company",
      },
    ],
  };

  componentDidMount = () => {
    fetch(
      "https://sbhs-web-server.herokuapp.com/lte/user/all"
      // "http://localhost:4000/lte/user/all"
    )
      .then((response) => response.json())
      .then((response) => {
        if (response) {
           this.state.result= response.map((row, index) => ({
            _id: row._id,
            key: row._id,
            name: row.name,
            company: row.company,
            password: row.password,
            batch: row.batch,
            email: row.email,
            usertype: row.usertype,
          }));
          // if (results.usertype === "Admin") {
            
            // console.log("result is here",this.state.result);
            // console.log("user type",{...this.state.result[8]});
            // this.setState({ users: this.state.result });
          // }
        }
      });
  };

  onSubmitUpdate = () => {
    fetch(
      "https://sbhs-web-server.herokuapp.com/lte/user/edit",
      // "http://localhost:4000/lte/user/edit",
      {
        method: "put",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: this.state.userId,
          name: this.state.name,
          batch: this.state.batch,
          usertype: this.state.usertype,
          email: this.state.email,
          company: this.state.company,
          password: this.state.password,
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        console.log("submit responce ", response);
        if (response && !response._id) {
          this.setState({
            errors: response,
          });
        } else {
          this.onClose();
          this.componentDidMount();
        }
      })
      .then(() => {
        this.successAlert("User Updated Successfully");
      });
  };

  handleSearchChange = (event) => {
    this.setState({ searchField: event.target.value });
  };

  successAlert = (text) => {
    message.success(text);
  };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    document.getElementById("create-user-form").reset();
    this.setState({
      visible: false,
      errors: {},
      name: "",
      username: "",
      email: "",
      designation: "",
      password: "",
      editMode: false,
      batch: "",
      usertype: "",
    });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  setModal2Visible(modal2Visible) {
    this.setState({ modal2Visible });
  }

  onSubmit = () => {
    console.log(this.state);
    fetch(
      "https://sbhs-web-server.herokuapp.com/lte/user/register",
      // "http://localhost:4000/lte/user/register",
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: this.state.name,
          company: this.state.company,
          email: this.state.email,
          batch: this.state.batch,
          username: this.state.username,
          usertype: this.state.usertype,
          coursesCompleted: [],
          password: this.state.password,
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        console.log("submit response ", response);
        if (response && !response._id) {
          this.setState({
            errors: response,
          });
        } else {
          console.log(response);
          this.onClose();
          this.successAlert("User added Succesfully");
          this.componentDidMount();
        }
      });
  };

  editUser = (user) => {
    this.setState({
      userId: user._id,
      name: user.name,
      username: user.username,
      email: user.email,
      batch: user.batch,
      usertype: user.usertype,
      password: user.password,
      visible: true,
      editMode: true,
    });
  };

  deleteUser = (id) => {
    fetch(
      `https://sbhs-web-server.herokuapp.com/lte/user/delete?_id=${id}`,
      // `http://localhost:4000/lte/user/delete?_id=${id}`,
      {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((response) => {
        this.onClose();
      })
      .then(() => {
        this.successAlert("User Deleted Successfully");
      })
      .then(() => {
        this.componentDidMount();
      });
  };

  handleCompanySelected = (value) => {
    this.setState({ company: value });
  };

  handleUserTypeSelected = (value) => {
    this.setState({ usertype: value });
  };

  render() {
    const { searchField, editMode, errors } = this.state;
    const {users}=this.props;
    const filteredUsers = users.filter((user) => {
      return user.name.toLowerCase().includes(searchField.toLowerCase());
    });
    return (
      <div className="MesdTable">
        {users.length === 0 ? (
          <div>
            <div className="loadingText"></div>
            <div className="tc f19 lh-copy">
              <Spin />
            </div>
          </div>
        ) : (
          <div>
            <Row
              style={{
                marginRight: "20px",
              }}
            >
              <Col md="2">
                <Button className="userButton" onClick={this.showDrawer}>
                  {"Add New User"}
                </Button>
              </Col>
              <Col md="2">
                <XslxGen
                  csvData={filteredUsers}
                  fileName={"Admin Data"}
                />
              </Col>
              <Col md="4" />
              <Col md="4">
                <Input
                  className="input"
                  placeholder="Search by Name.."
                  onChange={this.handleSearchChange}
                  type="search"
                />
              </Col>
            </Row>

            <div className="TableScrollbar">
              <Table
                bordered
                dataSource={filteredUsers}
                columns={this.state.columns}
                scroll={{ y: 650 }}
                pagination={false}
              />
            </div>
          </div>
        )}

        <Drawer
          title="Add New User"
          width={window.innerWidth > 500 ? 640 : window.innerWidth - 150}
          onClose={this.onClose}
          visible={this.state.visible}
          style={{ backgroundColor: "#0000008a" }}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button
                className="mButton"
                style={{ marginRight: 8 }}
                onClick={() => {
                  editMode ? this.onSubmitUpdate() : this.onSubmit();
                }}
                type="primary"
              >
                {editMode ? "Update" : "Submit"}
              </Button>
              <Button className="mButton" onClick={this.onClose}>
                Cancel
              </Button>
            </div>
          }
        >
          <Form id="create-user-form" layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Name"
                  rules={[
                    {
                      required: true,
                      message: errors.name,
                    },
                  ]}
                >
                  <Input
                    name="name"
                    value={this.state.name}
                    error={errors.name}
                    onChange={this.onChange}
                    placeholder="Please enter Name"
                  />
                  <Label className="red">{errors.name}</Label>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  label="Batch"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Batch",
                    },
                  ]}
                >
                  <Input
                    name="batch"
                    value={this.state.batch}
                    type="number"
                    onChange={this.onChange}
                    placeholder="Please Enter Batch"
                  />
                  <Label className="red">{errors.batch}</Label>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: "Please enter email address",
                    },
                  ]}
                >
                  <Input
                    name="email"
                    value={this.state.email}
                    onChange={this.onChange}
                    placeholder="Please enter email address"
                  />
                  <Label className="red">{errors.email}</Label>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  label="Company"
                  rules={[
                    {
                      required: true,
                      message: errors.company,
                    },
                  ]}
                >
                  <Select
                    defaultValue="WORK"
                    allowClear
                    value={this.state.company}
                    // error={errors.domain}
                    onChange={this.handleCompanySelected}
                  >
                    <Option value="WORK">WORK</Option>
                    <Option value="SBHS">SBHS</Option>
                  </Select>
                  <Label className="red">{errors.company}</Label>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  label="User Type"
                  rules={[
                    {
                      required: true,
                      message: errors.usertype,
                    },
                  ]}
                >
                  <Select
                    defaultValue="Agent"
                    allowClear
                    value={this.state.usertype}
                    // error={errors.domain}
                    onChange={this.handleUserTypeSelected}
                  >
                    <Option value="Agent">Agent</Option>
                    <Option value="Admin">Admin</Option>
                  </Select>
                  <Label className="red">{errors.usertype}</Label>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Password",
                    },
                  ]}
                >
                  <Input
                    value={this.state.password}
                    name="password"
                    onChange={this.onChange}
                    placeholder="Please enter Password"
                  />
                  <Label className="red">{errors.password}</Label>
                </Form.Item>
              </Col>
              <Col span={12}></Col>
            </Row>
          </Form>
          <Row gutter={16}>
            <Col span={4}>
              {editMode ? (
                <Popconfirm
                  placement="right"
                  title="Do you want to delete ？"
                  okText="Yes"
                  cancelText="No"
                  onConfirm={() => {
                    this.deleteUser(this.state.userId);
                  }}
                >
                  <img
                    alt="deleteBtn"
                    src={deleteBtn}
                    className="delButton grow"
                    style={{
                      textAlign: "left",
                      width: "25px",
                    }}
                  />
                </Popconfirm>
              ) : null}
            </Col>
            <Col span={20}></Col>
          </Row>
        </Drawer>
      </div>
    );
  }
}
